module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Alarm-clock-0a2d692acf415ce90326d94446642832.svg";